import $ from 'jquery';
import { ready } from 'core-utilities';
import { EventStream } from 'Roblox';

ready(() => {
  const trackReportItemClick = () => {
    const itemContainer = document.querySelector<HTMLDivElement>('#item-container');

    if (EventStream && itemContainer) {
      const params = {
        assetId: itemContainer.dataset.itemId,
        assetTypeId: itemContainer.dataset.assetTypeId,
        userId: itemContainer.dataset.userId
      };

      EventStream.SendEventWithTarget(
        'ReportAssetClicked',
        'Library',
        params,
        EventStream.TargetTypes.WWW
      );
    }
  };

  const popoverElement = $(".rbx-menu-item.item-context-menu[data-toggle='popover']");
  popoverElement.on('inserted.bs.popover', () => {
    const element = document.querySelector('#report-item');
    if (element) {
      element.addEventListener('click', trackReportItemClick);
    }
  });

  popoverElement.on('hide.bs.popover', () => {
    const element = document.querySelector('#report-item');
    if (element) {
      element.removeEventListener('click', trackReportItemClick);
    }
  });
});
